<template>
  <div class="video-container">
    <div class="button-container sub-1">
      <button @click="goToMoreEpisodes" class="button button-1">MORE EPISODES</button>
      <button  @click="getSurpriseProject" class="button button-2">SURPRISE ME</button>
    </div>
    <div class="iframe-container">
      <iframe :src="getVideoLink(post.body)" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <div @click="goVideo(getVideoLink(post.body))" class="overlay-iframe"></div>
    </div>
    <div class="metadata-container">
      <div class="meta-by meta-sub">
        <p class="meta-title">BY</p>
        <p class="meta-content">{{project.user.fullName.toUpperCase()}}</p>
      </div>
      <div class="meta-published meta-sub">
        <p class="meta-title">PUBLISHED</p>
        <p class="meta-content">{{formatDate(project.published ? project.published: project.created)}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import componentState from '@/mixins/component-state'
import misc from '@/mixins/misc'

const tvCategoryID = 266

export default {
  props: ['project', 'post'],
  data: function () {
    return {
      selectedTvCategory: {},
      surpriseProjectID: 0
    }
  },
  mixins: [componentState, misc],
  mounted: function () {
    this.getCategory()
  },
  methods: {
    getVideoLink: function (body) {
      let videoUrl = this.getRegex(body)
      videoUrl = videoUrl[1]
      return videoUrl
    },
    getRegex: function (body) {
      const regex = /\[video-embed\]\((.*)\)/
      const videoUrl = body.match(regex)
      return videoUrl
    },
    formatDate: function (date) {
      return moment(date).format('MMM DD, YYYY')
    },
    goVideo: function (url) {
      this.$store.dispatch('showVideoTourModal', { fromLandingPage: true, fromSourcePage: true, url: url })
    },
    goToMoreEpisodes: function () {
      this.$router.push({ path: '/viewAll?category=' + this.selectedTvCategory.slug })
    },
    getCategory: function () {
      const categories = this.project.categories
      this.selectedTvCategory = categories.find(category => category.parentID === tvCategoryID)
    },
    getSurpriseProject: function () {
      const params = {}
      params.slug = 'tv'
      params.sort = 'random'
      params.limit = 1
      params.offset = 0
      params.pinned = false
      this.$store.dispatch('getProjectsByCategory', params).then((response) => {
        this.surpriseProjectID = response.projects[0].slug
        window.open(`/story/${this.surpriseProjectID}`, '_self')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
    iframe {
      width: 100%;
      height: 19rem;
    }
  .button-container {
    display: flex;
    justify-content: flex-end;
    @include mobile {
      justify-content: center;
    }
    .button {
      margin-bottom: 1rem;
      border-radius: 0;
      font-size: 0.8rem;
    }
    .button-1 {
      background-color: $primary;
      border-color: transparent;
      color: #fff;
      margin-right: 1rem;
    }
    .button-2 {
      background-color: transparent;
      border-color: black;
      color: black;
    }
  }
  .metadata-container {
    display: flex;
    align-self: flex-start;
    padding-top: 0.5rem;
    p {
      padding: 0;
    }
    @include mobile {
      align-self: center;
    }
    .meta-sub {
      display: flex;
      flex-direction: column;
      margin-right: 1.5rem;
      .meta-title {
        font-size: 0.7rem;
        margin-bottom: 0.3rem;
        color: #7a7a7a;
        cursor: default;
      }
      .meta-content {
        color: #4a4a4a;
        font-weight: 600;
        font-size: 0.75rem;
      }
    }
    @include mobile {
      align-items: center;
    }
  }
  .video-container {
    width: 100%;
    @include mobile {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
    }
  }
  .iframe-container{
    position: relative;
    @include mobile {
    display: flex;
    justify-content: center;
    width: fit-content;
    }
  }
  .overlay-iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: transparent;
    &:hover {
      cursor: pointer;
      background-color: rgba(122, 42, 144, 0.3);
      transition: 0.3s;
    }
  }

</style>
